<template>
    <el-dialog
    :title="operate == 'add'?'新增设备':'编辑设备'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="600px"
    :before-close="close">
    <div class='dev-type-root'>
      <div class="box">
        <div class="title">
          自定义名称
        </div>
        <div class="content">
          <el-input v-model="params.customName"  style="width: 100%;" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="box">
        <div class="title">
          产品名称
        </div>
        <div class="content">
          <el-input v-model="params.productName" style="width: 100%;" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="box">
        <div class="title">
          产品型号
        </div>
        <div class="content">
          <el-input v-model="params.productModel" style="width: 100%;" placeholder="请输入"></el-input>
        </div>
      </div><div class="box">
        <div class="title">
          设备类型
        </div>
        <div class="content">
          <el-radio v-for="(item,index) in devTypeList" v-model="params.deviceType" :label="item.id">{{ item.label }}</el-radio>
        </div>
      </div>
      <!-- <div class="box" v-show="false">
        <div class="title">
          设备模型
        </div>
        <div class="content">
          <el-radio v-for="(item,index) in devModeilList" v-model="params.standardModel" :label="item.id">{{ item.label }}</el-radio>
        </div>
      </div> -->
      <div class="box">
        <div class="title">
          功耗类型
        </div>
        <div class="content">
          <el-radio v-model="params.powerConsumption" :label="1">标准功耗</el-radio>
          <el-radio v-model="params.powerConsumption" :label="0">低功耗</el-radio>
        </div>
      </div>
      <div class="box">
        <div class="title">
          通讯协议
        </div>
        <div class="content">
          <el-radio style="width: 80px;margin-bottom: 5px;" v-for="(item,index) in radioList" :key="index" v-model="params.networkType" :label="item.id">{{ item.label }}</el-radio>
        </div>
      </div>
      <div class="box">
        <div class="title">
          备注信息
        </div>
        <div class="content">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="params.remark">
          </el-input>
        </div>
      </div>
      <div class="box" v-show="operate != 'addChildrean'">
        <div class="title">
          产品图片
        </div>
        <div class="content">
          <UpLoadImng @getBase64="getBase64" ref="upload" />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { iotApi } from '../../../../../../utils/config'
import { postFun } from '../../../../../../utils/httpFun'
import UpLoadImng from "../../../component/upload-block.vue";
export default {
  components:{
    UpLoadImng
  },
  data() {
    return {
      edit:{},
      operate: 'add',
      dialogVisible:false,
      serachCallback:function (){},
      devModeilList:[
        {
         id:0,
         label:'非标准模型' 
        },
        {
         id:1,
         label:'标准模型' 
        }
      ],
      radioList:[
        {
          id:-1,
          label:'其他'
        },
        {
          id:0,
          label:'WIFI'
        },
        {
          id:1,
          label:'NB'
        },
        {
          id:2,
          label:'4G'
        },
        {
          id:3,
          label:'LoRa'
        },
        {
          id:4,
          label:'ZigBee'
        },
        {
          id:5,
          label:'蓝牙'
        }
      ],
      devTypeList:[
        {
         id:0,
         label:'普通设备' 
        },
        {
         id:1,
         label:'网关设备' 
        },
        {
         id:2,
         label:'子设备' 
        }
      ],
      params:{
        cId:null,
        factoryId:0,
        customName:'',
        productName:'',
        productModel:'',
        deviceType:0,
        remark:'',
        powerConsumption:1,
        icon:'',
        networkType:-1
      }
    };
  },
  methods:{
    open(operate,item,serachCallback){
      this.operate = operate;
      
      
      this.serachCallback = serachCallback;
      console.log('查询',serachCallback)
      this.edit = item;
      console.log('创建',this.edit)
      let user = JSON.parse(window.localStorage.getItem('BrenPlivateMessage'))
      console.log('个人信息',user);
      try{
        this.params.cId = this.edit.cId;
      }catch{

      }

      this.params.factoryId = user.id;

      this.dialogVisible = true;
      if(operate == 'edit'){
        console.log('编辑',this.edit)
        
        this.params.cId = this.edit.cId;
        this.params.factoryId = this.edit.factoryId;
        this.params.customName = this.edit.customName;
        this.params.productName = this.edit.productName;
        this.params.productModel = this.edit.productModel;
        this.params.deviceType = this.edit.deviceType;
        this.params.remark = this.edit.remark;
        this.params.icon = this.edit.icon;
        this.params.powerConsumption = this.edit.powerConsumption;
        this.params.networkType = this.edit.networkType;


        this.$nextTick(()=>{
          this.$refs.upload.setVal(this.edit.icon,'imgSrc');
          this.$refs.upload.setVal(false,'isShow');
        })
      }
     
    },
    close(){
      this.$refs.upload.setVal({});
      this.params = {
        cId:null,
        factoryId:0,
        customName:'',
        productName:'',
        productModel:'',
        deviceType:0,
        remark:'',
        icon:'',
        powerConsumption:1,
        networkType:-1
      }
      console.log('关闭')
      this.dialogVisible = false;
    },
    getBase64(base64){
      this.params.icon = base64;
    },
    submit(){
      let arr = [
      {
        key:'cId',
        message:'暂无cId'
      },
      {
        key:'factoryId',
        message:'请获取用户id'
      },
      {
        key:'customName',
        message:'请输入用户名称'
      },{
        key:'productName',
        message:'请输入产品名称'
      },{
        key:'productModel',
        message:'请输入产品型号'
      },{
        key:'deviceType',
        message:'请选择设备类型'
      },{
        key:'icon',
        message:'请选择产品图片'
      },{
        key:'powerConsumption',
        message:'请选择功率类型'
      }]

      if(this.params.networkType == null || this.params.networkType == undefined){
        this.$message.warning('请选择通信协议');
        return;
      }

      for(let index in arr){
        if(typeof this.params[arr[index].key] == 'number'){
          if(this.params[arr[index].key] < 0){
            this.$message.warning(arr[index].message);
            return;
          }
        }else if(!!!this.params[arr[index].key]){
          this.$message.warning(arr[index].message);
          return;
        }
      }

      let param = {
       ...this.params
      }
      if(this.operate == 'add'){
        console.log(';====add',this.edit,param)
        postFun(iotApi.CREATEPRODUCT,{...param,factoryId:0,state:0},res=>{
          if(res.data){
            this.$message.success("创建成功");
            this.serachCallback(res.data);
          }else{
            this.$message.warning("创建失败");
          }
          this.close();
        })
      }else if(this.operate == 'edit'){
        console.log('======编辑')
        param.id = this.edit.id;
        postFun(iotApi.UPDATEBYPRIMARYKEYPRODUCT,param,res=>{
          if(res.data){
            this.$message.success("编辑成功");
            console.log('==========成功')
            console.log('查询',this.serachCallback)
            this.serachCallback('edit');
          }else{
            this.$message.warning("编辑失败");
          }
          this.close();
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dev-type-root{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .box{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .title{
    text-align: right;
    width: 80px;
    margin-right: 20px;
  }
  .content{
    width: 330px;
  }
  ::v-deep .el-dialog__header{
    width: 92% !important;
    height: 23px;
    // background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
    margin-bottom: 20px;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
</style>